import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import './common.css';
import Home from './views/Home';
import List from './views/List';
import Single from './views/Single';
import Search from './views/Search';
import SearchTag from './views/SearchTag';
import { RecoilRoot } from 'recoil';
import ScrollTop from './components/ScrollTop';
import Writer from './views/Writer';
import Pocket from './views/Pocket';
import Card from './views/Card';
import { HelmetProvider } from 'react-helmet-async';
import BusinessCard from './components/BusinessCard';
import Pocketlist from './views/PocketList';
import Popup from './components/Popup';
import Android from './components/Android';
import IOS from './components/Popup';

function App() {
	return (
		<HelmetProvider>
			<title>KB데이타시스템 공식 블로그</title>
			<meta
				name="description"
				content="KB금융그룹의 IT선진화 및 혁신을 이끌기 위해 설립된 금융 IT 전문기업, KB데이타시스템의 공식 블로그입니다."
			/>
			<div className="App">
				<RecoilRoot>
					<BrowserRouter>
						<Routes>
							<Route path="/" element={<Home />}></Route>
							<Route exact={true} path="/blog/series/:ID" element={<List />} />
							<Route exact={true} path="/blog/:ID" element={<Single />} />
							<Route exact={true} path="/s" element={<Search />} />
							<Route exact={true} path="/s/:keyword" element={<Search />} />
							<Route exact={true} path="/tag" element={<SearchTag />} />
							<Route
								exact={true}
								path="/tag/:keyword"
								element={<SearchTag />}
							/>
							<Route exact={true} path="/author/:id" element={<Writer />} />
							<Route exact={true} path="/pocket" element={<Pocket />} />
							<Route
								exact={true}
								path="/card/:id"
								element={<BusinessCard active={1} />}
							/>
							<Route exact={true} path="/pocketlist" element={<Pocketlist />} />
							{/* <Route exact={true} path="/popup" element={<Android />} /> */}
							{/* <Route exact={true} path="/ios" element={<IOS />} /> */}
						</Routes>
						<ScrollTop />
					</BrowserRouter>
				</RecoilRoot>
			</div>
		</HelmetProvider>
	);
}

export default App;
